<template>
   <!-- 弹窗 -->
   <el-dialog title="文件上传" :visible.sync="dialogVisible" width="500px" :before-close="_handleClose">
      <div style="text-align: left;" v-if="['6','10','16'].includes(this.attachType)>0"><span style="margin-right: 40px" >选择年月:</span>
         <el-date-picker
             v-model="inputMonth"
             type="month"
             placeholder="Pick a month"
             format="yyyy-MM"
             value-format="yyyy-MM"
         />
      </div>
      <div class="innerdialog_list">
         <p class="listP">选择文件：</p>
         <el-upload ref="upload" style="display: inline-block;" :accept="acceptList"
                    :show-file-list="false" action=""
                    :http-request="_httpRequest"
                    :before-upload="_beforeUpload"
                    :file-list="fileList" multiple>
            <span class="specilSpan">···</span>
         </el-upload>
         <div style="padding-left: 10px;">
            <small>图片文件最大允许10M，其它文件大小最大允许50M</small>
         </div>
      </div>

      <div class="list_center">
         <div class="inner_upload" v-for="(item,index) in fileList" :key="index">
            <p>{{ index + 1 }}&nbsp;&nbsp;{{ item.name }}</p>
            <img src="@/assets/img/login/cuowu.png" @click="_deleteUpload(index,item.url)">
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">返回</el-button>
			<el-button type="primary" @click="_confirmUpload">确认上传</el-button>
		</span>
   </el-dialog>
</template>

<script>
import {client} from '@/utils/oss.js'
import ruiTool from '@/utils/ruiTool'
import {uploadFiles, deleteUploadFiles} from '@/api/modules/paData'

export default {
   data() {
      return {
         dialogVisible: false,
         filePathName: '浙江项目绿色工程',
         //申请的项目编号,
         prjApplyID: '',
         //关联的附件类型
         attachType: '',
         //接收文件类型
         acceptList: '',
         //上传的信息
         fileList: [],
         inputMonth:'',
      }
   },
   components: {},
   filters: {
      titleFilter(value) {
         if (value.length > 18) {
            const newVluae = value.split('.')[0].slice(0, 15) + '···.' + value.split('.')[1]
            return newVluae
         }
         return value
      }
   },
   methods: {
      //显示对话框
      showDialog(prjApplyID, attachType, acceptList, fileList) {
         this.dialogVisible = true
         this.prjApplyID = prjApplyID;
         this.attachType = attachType;
         this.acceptList = acceptList;
         this.fileList = fileList.slice(0);
         this.inputMonth=''
      },
      //文件确认上传
      _confirmUpload() {
         if (this.fileList.length == 0) {
            this.dialogVisible = false
            return
         }
         //调用后台接口将文件路径写入到数据库，成功后，完成回传和关闭对话框操作
         const fileNameList = [];
         const filePathList = [];
         for (let item of this.fileList.values()) {
            if (ruiTool.isNotNull(item.id)) {
               fileNameList.push(item.name);
               filePathList.push(item.url);
            }
         }
         const param = {
            prjApplyId: this.prjApplyID,
            attachType: this.attachType,
            loginUser: localStorage.getItem('loginName'),
            fileNameList: fileNameList,
            filePathList: filePathList,
         };
         uploadFiles({
            data: param,
            success: (res) => {
               this.$message.success("上传成功");
               //回传数据
               this.$emit('uploadCompleted', {
                  attachType: this.attachType,
                  uploadFileList: this.fileList
               })
               this.dialogVisible = false
               setTimeout(() => {
                  this.fileList = []
               })
            }
         })
      },
      /*删除上传文件*/
      _deleteUpload(index, url) {
         deleteUploadFiles({
            data: {path: url},
            success: (res) => {
               this.$message.success("删除成功");
               this.fileList.splice(index, 1)
               console.log('文件列表', this.fileList);
            }
         })
      },
      //上传前检查文件大小
      _beforeUpload(file) {
         let isLt2M
         if (file.type.indexOf('image') != -1) {
            isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
               this.$message.error('图片大小不能超过 10M !');
            }
         } else {
            isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
               this.$message.error('非图片文件不能超过 50M !');
            }
         }
         return isLt2M;
      },
      //自定义上传的实现，上传到OSS
      _httpRequest({file}) {

         //判断时间是否已经输入了
         if(['4','8','14'].includes(this.attachType)>0 && this.inputMonth ==''){
            this.$message.error("先输入年月");
            return;
         }

         const fileName = `${this.filePathName}/${Date.parse(new Date())}/${file.name}`; //定义唯一的文件名
         client.put(fileName, file).then(({res, url, name}) => {
            if (res && res.status == 200) {
               console.log(res)
               //回显文件name用
               this.fileList.push({
                  url: url,
                  id: fileName,
                  name: this.inputMonth + file.name,
               })
               console.log('文件列表', this.fileList);
            }
         }).catch((err) => {
            console.log(`阿里云OSS上传失败回调`, err);
         });
      },
      /*对话框关闭*/
      _handleClose() {
         this.dialogVisible = false
      }
   }
}
</script>

<style scoped="scoped">
.el-dialog__header {
   height: 100px;
   line-height: 100px;
}

.el-dialog__body {
   padding: 10px 20px;
}

>>> .el-dialog {
   border-radius: 6px;
}

/* 模板下载 */
.mubanDown {
   display: flex;
   height: 40px;
   line-height: 40px;
   justify-content: space-between;
   align-items: center;
}

.mubanDown button {
   cursor: pointer;
   width: 80px;
   height: 35px;
   line-height: 35px;
   border: 1px solid #1890FF;
   font-size: 12px;
   background-color: #ffffff;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #1890FF;
}

.innerdialog_list {
   display: flex;
   /* height: 40px; */
   align-items: flex-start;
   line-height: 40px;
   align-content: flex-start;
   margin-bottom: 10px;
   border-bottom: 1px solid #B5B5B5;
}

/* .innerdialog_list p {

} */
.listP {
   font-size: 14px;
   width: 80px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #000000;
}

.innerdialog_list span {
   display: block;
   font-size: 12px;
   width: 40px;
   margin-left: 20px;
   height: 20px;
   line-height: 20px;
   background: #FFFFFF;
   text-align: center;
   border: 1px solid #1890FF;
   cursor: pointer;
}

.list_center {
   width: 310px;
   min-height: 40px;
   display: flex;
   align-content: flex-start;
   flex-wrap: wrap;
}

/* 每个上传文件的样式 */
.inner_upload {
   position: relative;
   min-height: 40px;
   margin: 0 10px;
   /* width: 100px; */
   /* overflow: scroll; */
}

.inner_upload p {
   color: #1890FF;
}

.inner_upload img {
   border-radius: 50%;
   position: absolute;
   right: -20px;
   top: 2px;
   width: 15px;
   height: 15px;
   cursor: pointer;
}

/* 保存提示 */
.tipList p {
   line-height: 25px;
   text-align: left;
}

.tipList p:first-child {
   margin-bottom: 20px;
}
</style>
